import React, { useState, useEffect } from 'react';
import Roadmap from "../components/Roadmap";
import api from "./api";
import "../styles/profile.css";
import { format } from 'date-fns-jalali';
import { FaUser } from "react-icons/fa";

const Profile = () => {
    const [profileData, setProfileData] = useState(null);
    const [scoresData, setScoresData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                // دریافت اطلاعات پروفایل (شامل شماره دانش‌آموز در فیلد username)
                const profileResponse = await api.get('/student/api/v1/show-student-profile/');
                setProfileData(profileResponse.data);
                
                // دریافت اطلاعات امتیازات
                const scoresResponse = await api.get('/student/api/v1/student-scores/me/');
                setScoresData(scoresResponse.data);
                
                setLoading(false);
            } catch (error) {
                console.error("خطا در دریافت اطلاعات پروفایل:", error);
                setLoading(false);
            }
        };

        fetchProfileData();
    }, []);

    if (loading) return <div className="text-center mt-5"></div>;
    if (!profileData || !scoresData) return <div className="text-center mt-5">خطا در دریافت اطلاعات</div>;

    // داده‌های پروفایل (شامل username که شماره دانش‌آموز است)
    const { username, first_name, last_name, date_of_birth, profile_image , phone_number } = profileData;
    const fullName = `${first_name} ${last_name}`;

    // داده‌های امتیازات
    const { my_score } = scoresData;

    return (
        <div className="me-lg-5 pe-lg-4">
            <div>
                <div className="row mt-3 mx-1 mx-lg-0 first-road">
                    <div className="col-lg-2 col-3">
                        <div className="profile-container">
                            {profile_image ? (
                                <img
                                    src={profile_image}
                                    alt={fullName}
                                    style={{ width: '100%', borderRadius: '50%' }}
                                />
                            ) : (
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                                    <FaUser style={{ fontSize: '40px', color: '#888' }} />
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="col-lg-3 col-9 mt-lg-4 mt-5 pe-4 pe-lg-0">
                        نام دانش آموز: {fullName}
                    </div>

                    {/* نمایش شماره دانش‌آموز از فیلد username */}
                    <div className="col-lg-3 col-6 mt-4">
                        شماره دانش آموز: {phone_number}
                    </div>

                    <div className="col-lg-3 col-6 pe-4 pe-lg-0 mt-4">
                        تاریخ تولد: {date_of_birth ? format(new Date(date_of_birth), 'yyyy/MM/dd') : 'ثبت نشده'}
                    </div>
                </div>

                <div className="row Grade mt-4">
                    {/* امتیاز کافه برنامه‌نویسی */}
                    <div className="col-lg-2 col-12">
                        <div>
                            <span style={{ color: "rgba(51, 177, 230, 1)", display: "flex", justifyContent: "center", marginBottom: "7px" }}>
                                امتیازات کافه برنامه نویسی
                            </span>
                            <span style={{ display: "flex", justifyContent: "center" }}>{my_score.cafe_programming_score} امتیاز</span>
                        </div>
                    </div>

                    <div className="col-lg-1 col-12 mt-4" style={{ color: "rgba(51, 177, 230, 1)", display: "flex", justifyContent: "center" }}>+</div>

                    {/* امتیاز شرکت در رویداد */}
                    <div className="col-lg-2 col-12">
                        <div>
                            <span style={{ color: "rgba(161, 207, 107, 1)", display: "flex", justifyContent: "center", marginBottom: "7px" }}>
                                امتیازات شرکت در رویداد
                            </span>
                            <span style={{ display: "flex", justifyContent: "center" }}>{my_score.event_participation_score} امتیاز</span>
                        </div>
                    </div>

                    <div className="col-lg-1 col-12 mt-4" style={{ color: "rgba(161, 207, 107, 1)", display: "flex", justifyContent: "center" }}>+</div>

                    {/* امتیاز دوره‌های گذرانده شده */}
                    <div className="col-lg-2 col-12">
                        <div>
                            <span style={{ color: "rgba(240, 139, 46, 1)", display: "flex", justifyContent: "center", marginBottom: "7px" }}>
                                امتیازات دوره‌های گذرانده
                            </span>
                            <span style={{ display: "flex", justifyContent: "center" }}>{my_score.course_completion_score} امتیاز</span>
                        </div>
                    </div>

                    <div className="col-lg-1 col-12 mt-4" style={{ color: "rgba(240, 139, 46, 1)", display: "flex", justifyContent: "center" }}>=</div>

                    {/* مجموع امتیازات */}
                    <div className="col-lg-2 col-12">
                        <div>
                            <span style={{ color: "rgba(155, 95, 199, 1)", display: "flex", justifyContent: "center", marginBottom: "7px" }}>
                                مجموع امتیاز ها تا الان
                            </span>
                            <span style={{ display: "flex", justifyContent: "center" }}>{my_score.total_score} امتیاز</span>
                        </div>
                    </div>
                </div>

                {/* جداکننده SVG */}
                <div className="my-4 d-lg-block d-none">
                    <svg width="1200" height="2" viewBox="0 0 1585 4" fill="none">
                        <line x1="0" y1="2" x2="1585" y2="2" stroke="url(#paint0_linear)" strokeWidth="4" />
                        <defs>
                            <linearGradient id="paint0_linear" x1="0" y1="0" x2="1585" y2="0">
                                <stop stopColor="#F5F7FA" />
                                <stop offset="0.48" stopColor="#34C759" />
                                <stop offset="1" stopColor="#F5F7FA" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>

                <div>
                    <Roadmap />
                </div>
            </div>
        </div>
    );
}

export default Profile;